import { useState } from "react";
import { MessageCircle, X } from "lucide-react";

export default function WhatsAppWidget() {
    const [open, setOpen] = useState(false);
    const [message, setMessage] = useState("");

    const phoneNumber = "919087304440";

    const sendMessage = () => {
        if (!message.trim()) return;

        const encodedMessage = encodeURIComponent(message);
        const url = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
        window.open(url, "_blank");
    };

    return (
        <div className="fixed bottom-6 right-6 z-50">
            <div className="relative">

                {/* Popup */}
                {open && (
                    <div className="absolute bottom-16 right-0 w-72 rounded-xl shadow-xl border bg-white p-4">
                        <div className="flex justify-between items-center mb-2">
                            <p className="font-semibold">Chat with us</p>
                            <button onClick={() => setOpen(false)}>
                                <X size={18} />
                            </button>
                        </div>

                        <textarea
                            placeholder="Type your message..."
                            className="w-full border rounded-md p-2 text-sm resize-none"
                            rows={3}
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                        />

                        <button
                            onClick={sendMessage}
                            className="mt-2 w-full bg-green-500 text-white rounded-md py-2 hover:bg-green-600"
                        >
                            Send on WhatsApp
                        </button>
                    </div>
                )}

                {/* Floating Button */}
                <button
                    onClick={() => setOpen(!open)}
                    className="bg-green-500 text-white p-4 rounded-full shadow-lg hover:bg-green-600"
                >
                    <MessageCircle />
                </button>

            </div>
        </div>
    );
}